import { DaperClient } from "@data/daper-client";

import { wrapResponse } from "./wrapResponse";

async function getNewslettersHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const daperClient = DaperClient.init({
    host: process.env.DAPER_URL,
    username: process.env.DAPER_USERNAME,
    password: process.env.DAPER_PASSWORD,
  });

  const daperResponse = await daperClient.getNewsletters();

  return res.status(200).json(daperResponse);
}

export default getNewslettersHandler;
